
<template>
    <div class="pagination-wrap">
        <el-pagination :layout="layout" :total="totalNumber" />
    </div>
</template>


<script>
// import { ArrowLeft } from '@element-plus/icons-vue';

export default {
    name: 'QuestionPagination',
    props: {
        layout: {
            type: String,
            default: 'prev, pager, next, sizes'
        },
        totalNumber: {
            type: Number,
            default: 1000
        }
    },
    components: {
        // ArrowLeft
    },
    data() {
        return {
            
        }
    }
}
</script>